<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
    <template #title>
      <h4>{{ isEdit ? $t('编辑') : $t('新增') }}</h4>
    </template>

    <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
      <el-form-item :label="$t('打赏金额')" prop="rewardPrice">
        <el-input :placeholder="$t('打赏金额')" v-model="formData.rewardPrice"/>
      </el-form-item>
      <el-form-item :label="$t('金额')" prop="price">
        <el-input :placeholder="$t('金额')" v-model="formData.price"/>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button size="medium" type="primary" @click="handleConfirm">{{$t('确认')}}</el-button>
      <el-button size="medium" @click="resetForm">{{$t('重置')}}</el-button>
    </template>

  </el-dialog>
</template>

<script>
import {resetEmpty} from "@/utils/common";

export default {
  name: "AwardForm",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showDialog: false,
      formData: {
        rewardPrice: "",
        price: null,
      },
      rules: {
        rewardPrice: [
          {required: true, message: this.$t('请输入打赏金额'), trigger: 'blur'}
        ],
        price: [
          {required: true, message: this.$t('请输入金额'), trigger: 'blur'},
          {pattern: /^[0-9]+([.]{1}[0-9]+){0,1}$/, message: this.$t('请输入正确的金额'), trigger: "blur"},
        ]
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$emit("save", {...this.formData});
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
    }
  },
  watch: {
    data: {
      handler(val) {
        console.log('val', val);
        for (const key in this.formData) {
          this.formData[key] = val[key];
        }
      },
    }
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}

</style>
